import { useState, useEffect, useRef } from "react";
import {
  Button,
  ButtonGroup,
  Row,
  Col,
  Form,
  Modal,
  // ToggleButtonGroup,
  // ToggleButton,
} from "react-bootstrap";
import { IntlProvider, FormattedMessage } from "react-intl";
import enMessages from "./locales/en.json";
import arMessages from "./locales/ar.json";
import SectionSeparator from "./components/SectionSeparator";
import SubSectionSeparator from "./components/SubSectionSeparator";
import AdmissionCountries from "./components/AdmissionCountries";
import { ToastContainer, toast } from "react-toastify";
import FilePicker from "./components/FilePicker";
import QASection from "./components/QASection";
import DatePicker from "react-datepicker";
import { FiPlus, FiMinus } from "react-icons/fi";
import moment from "moment";
import ReCAPTCHA from "react-google-recaptcha";
import SignaturePad from "./components/SignaturePad";
// import CenterDropdown from "./components/CenterDropdown";

var Chance = require("chance");
var chance = new Chance();

const App = () => {
  // Get query parameters
  const queryParameters = new URLSearchParams(window.location.search);
  const aid = queryParameters.get("aid");

  // Refs
  const recaptcha = useRef();

  // Constants
  const center_uuid = { 505: "a1c63808-3814-40eb-aa26-b25560b58b32" };
  const version = "2.1";
  const API_URL = process.env.REACT_APP_API_URL;
  const PORTAL_URL = process.env.REACT_APP_PORTAL_URL;
  const messages = {
    en: enMessages,
    ar: arMessages,
  };
  const steps = [
    { name: "step.student_details", step: 1 },
    { name: "step.required_documents", step: 2 },
    // { name: "step.individual_profile_plan", step: 3 },
    { name: "step.visual_media_consent", step: 3 },
    { name: "step.clinic_information", step: 4 },
    { name: "step.known_allergies", step: 5 },
    { name: "step.question_answer", step: 6 },
    { name: "step.terms_conditions", step: 7 },
  ];
  const allergyOptions = [
    "Cow’s Milk",
    "Eggs",
    "Peanuts",
    "Tree Nuts (Almonds, Walnuts)",
    "Wheat",
    "Soy",
    "Fish",
    "Sesame",
    "Pollen",
    "Dust Mites",
    "Pet Allergy",
    "Insect Stings",
    "Medications",
    "Latex",
    "Any Contact Allergens",
    "No Known Allergies",
  ];
  const chronicIllnesses = [
    "Vision Impairment",
    "Epilepsy",
    "Diabetes Type 1",
    "Diabetes Type 2",
    "Gastric Disorders",
    "Hearing Difficulties",
    "Heart Disease",
    "Blood Disorders",
    "Kidney Disease",
    "Liver Disease",
    "Autoimmune Disease",
    "Asthma",
    "High Blood Pressure",
    "N/A",
  ];
  const errorsObj = {
    // center_id: false,
    captcha: false,
    child_name: false,
    child_family_name: false,
    birth_date: false,
    gender: false,
    religion: false,
    country_id: false,
    id_number: false,
    // agegroup_id: false,
    spouse_role: false,
    father_name: false,
    father_mobile: false,
    father_email: false,
    mother_name: false,
    mother_mobile: false,
    mother_email: false,
    emergency_contact1: false,
    emergency_relation1: false,
    emergency_phone1: false,
    bloodgroup: false,
  };

  // State
  const [signature, setSignature] = useState(null);
  const [locale, setLocale] = useState("en");
  const [countries, setCountries] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [languages, setLanguages] = useState([]);
  // const [ageGroup, setAgeGroup] = useState([]);
  const [admissionAttachments, setAdmissionAttachments] = useState([]);
  const [errors, setErrors] = useState(errorsObj);
  const [step, setStep] = useState(1);
  const [stepName, setStepName] = useState("step.student_details");
  const [formSaving, setFormSaving] = useState(false);
  const [formData, setFormData] = useState({
    admission_id: 0,
    center_id: 505,
    // center_uuid: "",
    child_name: "",
    child_middle_name: "",
    child_family_name: "",
    birth_date: "",
    gender: "",
    country_id: "",
    religion: "",
    id_number: "",
    // agegroup_id: "",
    sponsor_role: "Father",
    father_name: "",
    father_mobile: "",
    father_workphone: "",
    father_email: "",
    father_employer: "",
    father_position: "",
    home_address: "",
    spouse_role: "Mother",
    mother_name: "",
    mother_mobile: "",
    mother_workphone: "",
    mother_email: "",
    mother_employer: "",
    mother_position: "",
    child_siblings: "",
    child_siblings_age: "",
    child_school_attending: "",
    emergency_contact1: "",
    emergency_relation1: "",
    emergency_phone1: "",
    admissioncountries: [],
    child_position_family: "1st Child",
    first_lang: "",
    second_lang: "",
    child_religion_food_clothing_desc: "",
    child_prev_settings: "",
    child_diet_milktype: "",
    child_diet_milktype_qty: "1",
    child_diet_milktype_freq: "1",
    child_weaningfood: "",
    child_weaningfood_volume: "1",
    child_weaningfood_freq: "1",
    child_weaningfood_snack: "",
    child_weaningfood_maincourse: "",
    child_weaningfood_puddings: "",
    child_sleep_time: "",
    child_sleep_mins: 1,
    child_sleep_comforters: "",
    child_use_toilet: [],
    child_use_drinkcup: "0",
    child_relate_children: 0,
    child_relate_familiar_adults: 0,
    child_take_turns: 0,
    notes: "",
    child_toys: "",
    child_activities: "",
    child_distress: "",
    child_extra_info: "",
    pic_nursery: 0,
    pic_media: 0,
    pic_social: 0,
    take_pictures: 1,
    bloodgroup: "",
    medical_emergency_name: "",
    medical_emergency_doc: "",
    medical_emergency_clinic: "",
    medical_emergency_phone: "",
    leela_allergies: "No",
    leela_dietry_intolerances: "No",
    leela_special_req: "No",
    allergies: "",
    allergic_reactions: "",
    attending_days: [],
    attending_times: [],
    qaAnswers: {},
    check_acknowledgement: 0,
    signature: "",
  });
  // const [otherAllergiesButtonValue, setOtherAllergiesButtonValue] = useState({
  //   leela_allergies_button: "No",
  //   leela_dietry_intolerances_button: "No",
  //   leela_special_req_button: "No",
  // });
  const [admission_question_answer, setAdmissionQuestionAnswer] = useState([]);
  const [health_declarations, setHealthDeclarations] = useState([]);
  const [picture, setPicture] = useState(null);
  const [child_eid_page, setChildEidPage] = useState(null);
  const [child_eid_page_back, setChildEidPageBack] = useState(null);
  const [child_passport, setChildPassport] = useState(null);
  const [visa_page, setVisaPage] = useState(null);
  const [birth_certcopy, setBirthCertcopy] = useState(null);
  const [vaccination_copy, setVaccinationCopy] = useState(null);
  const [prev_school_rep_doc, setPrevSchoolRepCopy] = useState(null);
  const [med_formcopy, setMedFormcopy] = useState(null);
  const [document1, setDocument1] = useState(null);
  const [father_id_attachment, setFatherIdAttachment] = useState(null);
  const [father_id_attachment_back, setFatherIdAttachmentBack] = useState(null);
  const [father_passport_attachment, setFatherPassportAttachment] =
    useState(null);
  // const [father_visa_attachment, setFatherVisaAttachment] = useState(null);
  const [mother_id_attachment, setMotherIdAttachment] = useState(null);
  const [mother_id_attachment_back, setMotherIdAttachmentBack] = useState(null);
  const [mother_passport_attachment, setMotherPassportAttachment] =
    useState(null);
  // const [mother_visa_attachment, setMotherVisaAttachment] = useState(null);

  const [chronicIllness, setChronicIllness] = useState("");
  const [chronicIllnessDesc, setChronicIllnessDesc] = useState("");
  const [chronicIllnessDate, setChronicIllnessDate] = useState("");

  const [illness, setIllness] = useState("");
  const [illnessDesc, setIllnessDesc] = useState("");
  const [illnessDate, setIllnessDate] = useState("");

  const [condition, setCondition] = useState("");
  const [conditionDesc, setConditionDesc] = useState("");
  const [conditionDate, setConditionDate] = useState("");

  // const [acknowledgement, setAcknowledgement] = useState(false);

  const [admissionAttachmentModal, setAdmissionAttachmentModal] = useState({
    show: false,
    title: "",
    content: "",
  });

  // On component load
  useEffect(() => {
    getCountries();
    getLanguages();
    if (aid) {
      getAdmissionData();
    }
  }, []);

  // On step change
  useEffect(() => {
    if (step === 7) {
      getAdmissionAttachments();
    }
  }, [step]);

  useEffect(() => {
    const initialAnswers = {};

    if (questions?.length && admission_question_answer?.length) {
      admission_question_answer.forEach((ans) => {
        const question = questions
          .flatMap((group) => group.admission_questions || [])
          .find((q) => q.adm_quest_id === ans.adm_quest_id);

        if (question) {
          const isTrueFalse = question?.adm_tf === 1;

          initialAnswers[ans.adm_quest_id] = {
            value: isTrueFalse
              ? ans.adm_ans_answer?.toString()
              : ans.adm_ans_comment || "",

            comment: isTrueFalse ? ans.adm_ans_comment || "" : "",
            adm_ans_id: ans.adm_ans_id,
          };
        }
      });

      setFormData((prevData) => ({
        ...prevData,
        qaAnswers: initialAnswers,
      }));
    }
  }, [questions, admission_question_answer]);

  // const handleCenterSelect = (centerObj) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     center_id: centerObj.center_id,
  //     center_uuid: centerObj.center_uuid,
  //   }));
  //   getActiveBoardAge(centerObj.center_id);
  // };

  // Get countries
  const getCountries = async () => {
    try {
      const response = await fetch(
        `${API_URL}/get-countries?tenant_id=f47ac10b58cc4372a5670e029j198745`,
        {
          method: "GET",
        }
      );
      if (response.ok) {
        const data = await response.json();
        setCountries(data);
      } else {
        console.log("NOT OK");
      }
    } catch (error) {
      console.log("Error!");
      console.log(error);
    }
  };

  // const getActiveBoardAge = async (center_id) => {
  //   try {
  //     const response = await fetch(
  //       `${API_URL}/get-active-board-age-groups?center_id=${center_id}`,
  //       {
  //         method: "GET",
  //       }
  //     );
  //     if (response.ok) {
  //       const data = await response.json();
  //       setAgeGroup(data);
  //     } else {
  //       console.log("NOT OK");
  //     }
  //   } catch (error) {
  //     console.log("Error!");
  //     console.log(error);
  //   }
  // };

  // Get languages
  const getLanguages = async () => {
    try {
      const response = await fetch(
        `${API_URL}/get-languages?tenant_id=f47ac10b58cc4372a5670e029j198745`,
        {
          method: "GET",
        }
      );
      if (response.ok) {
        const data = await response.json();
        setLanguages(data);
      } else {
        console.log("NOT OK");
      }
    } catch (error) {
      console.log("Error!");
      console.log(error);
    }
  };

  // Get Admission Attachments
  const getAdmissionAttachments = async () => {
    try {
      const response = await fetch(
        `${API_URL}/get-admission-attachments?center_id=${formData.center_id}&tenant_id=f47ac10b58cc4372a5670e029j198745`,
        {
          method: "GET",
        }
      );
      if (response.ok) {
        const data = await response.json();
        console.log("data", data);
        setAdmissionAttachments(data);
      } else {
        console.log("NOT OK");
      }
    } catch (error) {
      console.log("Error!");
      console.log(error);
    }
  };

  // Get admission data
  const getAdmissionData = async () => {
    try {
      const response = await fetch(
        `${API_URL}/get-admission-data?admission_uuid=${aid}&tenant_id=f47ac10b58cc4372a5670e029j198745`,
        {
          method: "GET",
        }
      );
      if (response.ok) {
        const data = await response.json();
        const {
          admission,
          admission_extra_info,
          children_health,
          admissioncountries,
          // admissionsiblings,
          admision_quest_answer,
        } = data;
        // const center_uuid = centers.find(
        //   (center) => center.center_id.toString() == admission.center_id
        // );
        // getActiveBoardAge(admission.center_id);
        setAdmissionQuestionAnswer(admision_quest_answer);
        setFormData((prevData) => ({
          ...prevData,
          center_id: admission.center_id,
          // center_uuid: center_uuid.center_uuid,
          admission_id: admission.admission_id,
          child_name: admission.child_name,
          child_middle_name: admission.child_middle_name,
          child_family_name: admission_extra_info.child_family_name,
          birth_date: admission.birth_date,
          gender: admission.gender,
          country_id: admission.country_id,
          religion: admission_extra_info.religion,
          id_number: admission.id_number,
          // agegroup_id: admission.agegroup_id,
          sponsor_role: admission_extra_info.sponsor_role ?? "Father",
          father_name: admission.father_name,
          father_mobile: admission.father_mobile,
          father_workphone: admission.father_workphone,
          father_email: admission.father_email,
          father_employer: admission.father_employer,
          father_position: admission.father_position,
          home_address: admission.home_address,
          spouse_role: admission_extra_info.spouse_role ?? "Mother",
          mother_name: admission.mother_name,
          mother_mobile: admission.mother_mobile,
          mother_workphone: admission.mother_workphone,
          mother_email: admission.mother_email,
          mother_employer: admission.mother_employer,
          mother_position: admission.mother_position,
          child_siblings: admission_extra_info.child_siblings,
          child_siblings_age: admission_extra_info.child_siblings_age,
          child_school_attending: admission_extra_info.child_school_attending,
          emergency_contact1: admission.emergency_contact1,
          emergency_relation1: admission.emergency_relation1,
          emergency_phone1: admission.emergency_phone1,
          admissioncountries: admissioncountries?.length
            ? admissioncountries
            : [],
          child_position_family:
            admission_extra_info.child_position_family ?? "1st Child",
          first_lang: admission.first_lang,
          second_lang: admission.second_lang,
          child_religion_food_clothing_desc:
            admission_extra_info.child_religion_food_clothing_desc,
          child_prev_settings: admission_extra_info.child_prev_settings,
          child_diet_milktype: admission_extra_info.child_diet_milktype,
          child_diet_milktype_qty: admission_extra_info.child_diet_milktype_qty,
          child_diet_milktype_freq:
            admission_extra_info.child_diet_milktype_freq,
          child_weaningfood: admission_extra_info.child_weaningfood,
          child_weaningfood_volume:
            admission_extra_info.child_weaningfood_volume,
          child_weaningfood_freq: admission_extra_info.child_weaningfood_freq,
          child_weaningfood_snack: admission_extra_info.child_weaningfood_snack,
          child_weaningfood_maincourse:
            admission_extra_info.child_weaningfood_maincourse,
          child_weaningfood_puddings:
            admission_extra_info.child_weaningfood_puddings,
          child_sleep_time: admission_extra_info.child_sleep_time,
          child_sleep_mins: admission_extra_info.child_sleep_mins,
          child_sleep_comforters: admission_extra_info.child_sleep_comforters,
          child_use_toilet: admission_extra_info.child_use_toilet
            ? JSON.parse(admission_extra_info.child_use_toilet)
            : [],
          child_use_drinkcup: admission_extra_info.child_use_drinkcup,
          child_relate_children: admission_extra_info.child_relate_children,
          child_relate_familiar_adults:
            admission_extra_info.child_relate_familiar_adults,
          child_take_turns: admission_extra_info.child_take_turns,
          notes: admission.notes,
          child_toys: admission_extra_info.child_toys,
          child_activities: admission_extra_info.child_activities,
          child_distress: admission_extra_info.child_distress,
          child_extra_info: admission_extra_info.child_extra_info,
          pic_nursery: admission_extra_info.pic_nursery,
          pic_media: admission_extra_info.pic_media,
          pic_social: admission_extra_info.pic_social,
          take_pictures: admission_extra_info.take_pictures,
          bloodgroup: admission.bloodgroup,
          medical_emergency_name: admission_extra_info.medical_emergency_name,
          medical_emergency_doc: admission_extra_info.medical_emergency_doc,
          medical_emergency_clinic:
            admission_extra_info.medical_emergency_clinic,
          medical_emergency_phone: admission_extra_info.medical_emergency_phone,
          leela_allergies: admission_extra_info.leela_allergies,
          leela_dietry_intolerances:
            admission_extra_info.leela_dietry_intolerances,
          leela_special_req: admission_extra_info.leela_special_req,
          allergies: admission.allergies,
          allergic_reactions: admission_extra_info.allergic_reactions,
          attending_days: admission_extra_info.attending_days
            ? JSON.parse(admission_extra_info.attending_days)
            : [],
          attending_times: admission_extra_info.attending_times
            ? JSON.parse(admission_extra_info.attending_times)
            : [],
          check_acknowledgement: admission.check_acknowledgement || 0,
          signature: admission_extra_info.signature || null,
        }));

        // setOtherAllergiesButtonValue((prevState) => ({
        //   ...prevState,
        //   leela_allergies_button:
        //     admission_extra_info.leela_allergies === "No" ? "No" : "Yes",
        //   leela_dietry_intolerances_button:
        //     admission_extra_info.leela_dietry_intolerances === "No"
        //       ? "No"
        //       : "Yes",
        //   leela_special_req_button:
        //     admission_extra_info.leela_special_req === "No" ? "No" : "Yes",
        // }));

        // Health Declarations
        if (children_health.length > 0) {
          const healthDeclarations = [];
          children_health.map((item) => {
            healthDeclarations.push({
              ...item,
              uuid: chance.guid(),
            });
          });
          setHealthDeclarations(healthDeclarations);
        }

        if (admission.picture) {
          setPicture({
            preview: `${
              PORTAL_URL + center_uuid[admission.center_id]
            }/admissions_school/${admission.picture}`,
          });
        }

        if (admission.child_eid_page) {
          setChildEidPage({
            preview: `${
              PORTAL_URL + center_uuid[admission.center_id]
            }/admissions_school/${admission.child_eid_page}`,
          });
        }

        if (admission_extra_info.child_eid_page_back) {
          setChildEidPageBack({
            preview: `${
              PORTAL_URL + center_uuid[admission.center_id]
            }/admissions_school/${admission_extra_info.child_eid_page_back}`,
          });
        }

        if (admission.child_passport) {
          setChildPassport({
            preview: `${
              PORTAL_URL + center_uuid[admission.center_id]
            }/admissions_school/${admission.child_passport}`,
          });
        }

        if (admission.visa_page) {
          setVisaPage({
            preview: `${
              PORTAL_URL + center_uuid[admission.center_id]
            }/admissions_school/${admission.visa_page}`,
          });
        }

        if (admission.birth_certcopy) {
          setBirthCertcopy({
            preview: `${
              PORTAL_URL + center_uuid[admission.center_id]
            }/admissions_school/${admission.birth_certcopy}`,
          });
        }

        if (admission.vaccination_copy) {
          setVaccinationCopy({
            preview: `${
              PORTAL_URL + center_uuid[admission.center_id]
            }/admissions_school/${admission.vaccination_copy}`,
          });
        }

        if (admission.med_formcopy) {
          setMedFormcopy({
            preview: `${
              PORTAL_URL + center_uuid[admission.center_id]
            }/admissions_school/${admission.med_formcopy}`,
          });
        }

        if (admission.prev_school_rep_doc) {
          setPrevSchoolRepCopy({
            preview: `${
              PORTAL_URL + center_uuid[admission.center_id]
            }/admissions_school/${admission.prev_school_rep_doc}`,
          });
        }

        if (admission.document1) {
          setDocument1({
            preview: `${
              PORTAL_URL + center_uuid[admission.center_id]
            }/admissions_school/${admission.document1}`,
          });
        }

        if (admission_extra_info.father_id_attachment) {
          setFatherIdAttachment({
            preview: `${
              PORTAL_URL + center_uuid[admission.center_id]
            }/admissions_school/${admission_extra_info.father_id_attachment}`,
          });
        }

        if (admission_extra_info.father_id_attachment_back) {
          setFatherIdAttachmentBack({
            preview: `${
              PORTAL_URL + center_uuid[admission.center_id]
            }/admissions_school/${
              admission_extra_info.father_id_attachment_back
            }`,
          });
        }

        if (admission_extra_info.father_passport_attachment) {
          setFatherPassportAttachment({
            preview: `${
              PORTAL_URL + center_uuid[admission.center_id]
            }/admissions_school/${
              admission_extra_info.father_passport_attachment
            }`,
          });
        }

        // if (admission_extra_info.father_visa_attachment) {
        //   setFatherVisaAttachment({
        //     preview: `${
        //       PORTAL_URL + center_uuid[admission.center_id]
        //     }/admissions_school/${admission_extra_info.father_visa_attachment}`,
        //   });
        // }

        if (admission_extra_info.mother_id_attachment) {
          setMotherIdAttachment({
            preview: `${
              PORTAL_URL + center_uuid[admission.center_id]
            }/admissions_school/${admission_extra_info.mother_id_attachment}`,
          });
        }

        if (admission_extra_info.mother_id_attachment_back) {
          setMotherIdAttachmentBack({
            preview: `${
              PORTAL_URL + center_uuid[admission.center_id]
            }/admissions_school/${
              admission_extra_info.mother_id_attachment_back
            }`,
          });
        }

        if (admission_extra_info.mother_passport_attachment) {
          setMotherPassportAttachment({
            preview: `${
              PORTAL_URL + center_uuid[admission.center_id]
            }/admissions_school/${
              admission_extra_info.mother_passport_attachment
            }`,
          });
        }

        if (admission_extra_info.signature) {
          setSignature({
            preview: `${
              PORTAL_URL + center_uuid[admission.center_id]
            }/admissions_school/${admission_extra_info.signature}`,
          });
        }

        // if (admission_extra_info.mother_visa_attachment) {
        //   setMotherVisaAttachment({
        //     preview: `${
        //       PORTAL_URL + center_uuid.center_uuid
        //     }/admissions_school/${admission_extra_info.mother_visa_attachment}`,
        //   });
        // }
      } else {
        console.log("NOT OK");
      }
    } catch (error) {
      console.log("Error!");
      console.log(error);
    }
  };

  // Handle language change
  const handleLanguageChange = (event) => {
    setLocale(event.target.value);
  };

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (
      name === "child_use_toilet_0" ||
      name === "child_use_toilet_1" ||
      name === "child_use_toilet_2"
    ) {
      const index = name.split("_")[3];
      let child_use_toilet = formData.child_use_toilet;
      child_use_toilet[index] = value;
      setFormData((prevData) => ({
        ...prevData,
        child_use_toilet,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  // Handle validation
  const validateStep = () => {
    let isValid = true;

    if (step === 1) {
      const captchaValue = recaptcha.current.getValue();

      if (!captchaValue) {
        errorsObj.captcha = true;
        isValid = false;
      }

      if (!picture) {
        errorsObj.picture = true;
        isValid = false;
      }

      // if (!formData.center_id) {
      //   errorsObj.center_id = true;
      //   isValid = false;
      // }

      if (!formData.child_name) {
        errorsObj.child_name = true;
        isValid = false;
      }

      if (!formData.child_family_name) {
        errorsObj.child_family_name = true;
        isValid = false;
      }

      if (!formData.birth_date) {
        errorsObj.birth_date = true;
        isValid = false;
      }

      if (!formData.gender) {
        errorsObj.gender = true;
        isValid = false;
      }
      if (!formData.religion) {
        errorsObj.religion = true;
        isValid = false;
      }

      if (!formData.country_id) {
        errorsObj.country_id = true;
        isValid = false;
      }

      if (!formData.id_number) {
        errorsObj.id_number = true;
        isValid = false;
      }

      if (!formData.father_name) {
        errorsObj.father_name = true;
        isValid = false;
      }

      if (!formData.father_mobile) {
        errorsObj.father_mobile = true;
        isValid = false;
      }

      if (!formData.father_email) {
        errorsObj.father_email = true;
        isValid = false;
      }

      if (!formData.mother_name) {
        errorsObj.mother_name = true;
        isValid = false;
      }

      if (!formData.mother_mobile) {
        errorsObj.mother_mobile = true;
        isValid = false;
      }

      if (!formData.mother_email) {
        errorsObj.mother_email = true;
        isValid = false;
      }

      if (!formData.emergency_contact1) {
        errorsObj.emergency_contact1 = true;
        isValid = false;
      }

      if (!formData.emergency_relation1) {
        errorsObj.emergency_relation1 = true;
        isValid = false;
      }

      if (!formData.emergency_phone1) {
        errorsObj.emergency_phone1 = true;
        isValid = false;
      }
    }

    if (step === 2) {
      if (!child_eid_page) {
        errorsObj.child_eid_page = true;
        isValid = false;
      }

      if (!child_eid_page_back) {
        errorsObj.child_eid_page_back = true;
        isValid = false;
      }
      if (!child_passport) {
        errorsObj.child_passport = true;
        isValid = false;
      }
      if (!birth_certcopy) {
        errorsObj.birth_certcopy = true;
        isValid = false;
      }
      if (!vaccination_copy) {
        errorsObj.vaccination_copy = true;
        isValid = false;
      }
      // if (!prev_school_rep_doc) {
      //   errorsObj.prev_school_rep_doc = true;
      //   isValid = false;
      // }
      if (!father_id_attachment) {
        errorsObj.father_id_attachment = true;
        isValid = false;
      }
      if (!father_id_attachment_back) {
        errorsObj.father_id_attachment_back = true;
        isValid = false;
      }

      if (!father_passport_attachment) {
        errorsObj.father_passport_attachment = true;
        isValid = false;
      }

      if (!mother_id_attachment) {
        errorsObj.mother_id_attachment = true;
        isValid = false;
      }
      if (!mother_id_attachment_back) {
        errorsObj.mother_id_attachment_back = true;
        isValid = false;
      }

      if (!mother_passport_attachment) {
        errorsObj.mother_passport_attachment = true;
        isValid = false;
      }
    }

    if (step === 4) {
      if (!formData.bloodgroup) {
        errorsObj.bloodgroup = true;
        isValid = false;
      }
      // if (health_declarations.length === 0) {
      //   errorsObj.chronicIllness = true;
      //   isValid = false;
      // }
      // if (!chronicIllness) {
      //   errorsObj.chronicIllness = true;
      //   isValid = false;
      // }
      // if (!chronicIllnessDesc) {
      //   errorsObj.chronicIllnessDesc = true;
      //   isValid = false;
      // }
      // if (!chronicIllnessDate) {
      //   errorsObj.chronicIllnessDate = true;
      //   isValid = false;
      // }
    }

    if (step === 5) {
      if (!formData.leela_allergies) {
        errorsObj.leela_allergies = true;
        isValid = false;
      }
    }

    if (step === 6) {
      questions?.forEach((group) => {
        group.admission_questions.forEach((q) => {
          const answerObj = formData.qaAnswers[q.adm_quest_id];
          const value = answerObj?.value;

          const isEmpty = value === undefined || value === null || value === "";
          if (q.adm_mandatory === 1 && isEmpty) {
            errorsObj[`qa_${q.adm_quest_id}`] = true;
            isValid = false;
          }
        });
      });
    }

    if (step === 7) {
      if (!signature) {
        errorsObj.signature = true;
        isValid = false;
      }
    }

    setErrors(errorsObj);
    return isValid;
  };

  // Handle Health Declaration Add
  const addHealthDeclaration = (child_health_type) => {
    const healthDeclaration = {
      child_health_name: "",
      child_health_desc: "",
      child_health_date: "",
    };

    if (child_health_type === "Chronic Illness") {
      if (!chronicIllness || !chronicIllnessDesc || !chronicIllnessDate) {
        toast.error(
          <FormattedMessage id="validation.fill_all_chronic_illness_fields" />
        );
        return;
      }

      healthDeclaration.child_health_name = chronicIllness;
      healthDeclaration.child_health_desc = chronicIllnessDesc;
      healthDeclaration.child_health_date = chronicIllnessDate;
    } else if (child_health_type === "Illness") {
      if (!illness || !illnessDesc || !illnessDate) {
        toast.error(
          <FormattedMessage id="validation.fill_all_illness_fields" />
        );
        return;
      }

      healthDeclaration.child_health_name = illness;
      healthDeclaration.child_health_desc = illnessDesc;
      healthDeclaration.child_health_date = illnessDate;
    } else if (child_health_type === "Condition") {
      if (!condition || !conditionDesc || !conditionDate) {
        toast.error(
          <FormattedMessage id="validation.fill_all_condition_fields" />
        );
        return;
      }

      healthDeclaration.child_health_name = condition;
      healthDeclaration.child_health_desc = conditionDesc;
      healthDeclaration.child_health_date = conditionDate;
    }

    setHealthDeclarations((prevHealthDeclarations) => [
      ...prevHealthDeclarations,
      {
        child_health_id: 0,
        uuid: chance.guid(),
        child_health_type,
        ...healthDeclaration,
      },
    ]);

    if (child_health_type === "Chronic Illness") {
      setChronicIllness("");
      setChronicIllnessDesc("");
      setChronicIllnessDate("");
    } else if (child_health_type === "Illness") {
      setIllness("");
      setIllnessDesc("");
      setIllnessDate("");
    } else if (child_health_type === "Condition") {
      setCondition("");
      setConditionDesc("");
      setConditionDate("");
    }
  };
  // Handle Health Declaration Remove
  const removeHealthDeclaration = (uuid) => {
    setHealthDeclarations((prevHealthDeclarations) =>
      prevHealthDeclarations.filter(
        (healthDeclaration) => healthDeclaration.uuid !== uuid
      )
    );
  };

  // Handle next step
  const handleNextStep = () => {
    handleSubmit(null);
  };

  function getPostData() {
    const postData = [];

    questions.forEach((group) => {
      group.admission_questions.forEach((q) => {
        const answerObj = formData.qaAnswers[q.adm_quest_id];

        const isTrueFalse = q.adm_tf === 1;

        postData.push({
          adm_ans_id: answerObj?.adm_ans_id || 0,
          center_id: formData?.center_id,
          admission_id: formData?.admission_id,
          adm_quest_id: q.adm_quest_id,
          adm_ans_answer: isTrueFalse
            ? answerObj?.value == 1
              ? 1
              : answerObj?.value == 0
              ? 0
              : null
            : 0,

          adm_ans_comment: isTrueFalse
            ? answerObj?.comment || null
            : answerObj?.value || null,
        });
      });
    });

    return postData;
  }

  // const handlePrevStep = () => {
  //   setStep(step - 1);
  // };

  //Handle button change
  // const handleButtonClick = (e) => {
  //   const { name, value } = e.target;

  //   // Update button value state
  //   setOtherAllergiesButtonValue((prevState) => ({
  //     ...prevState,
  //     [name]: value,
  //   }));

  //   if (name === "leela_special_req_button") {
  //     setFormData((prevFormData) => ({
  //       ...prevFormData,
  //       leela_special_req: value === "No" ? "No" : "",
  //     }));
  //   } else if (name === "leela_dietry_intolerances_button") {
  //     setFormData((prevFormData) => ({
  //       ...prevFormData,
  //       leela_dietry_intolerances: value === "No" ? "No" : "",
  //     }));
  //   } else if (name === "leela_allergies_button") {
  //     setFormData((prevFormData) => ({
  //       ...prevFormData,
  //       leela_allergies: value === "No" ? "No" : "",
  //     }));
  //   }
  // };

  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl?.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  const handleUpload = async (file) => {
    try {
      const fD = new FormData();
      fD.append("file", file);
      fD.append("field_name", "signature");
      fD.append("admission_id", formData.admission_id);

      const response = await fetch(
        `${API_URL}/upload-doc?tenant_id=f47ac10b58cc4372a5670e029j198745`,
        {
          method: "POST",
          body: fD,
        }
      );

      if (response.ok) {
        const data = await response.json();
        const { data: resData } = data;

        const signaturePath = resData["signature"];
        // console.log("Uploaded signature:", signaturePath);

        file.preview = `${
          PORTAL_URL + formData.center_uuid
        }/admissions_school/${signaturePath}`;
        setSignature(file);

        // 🔹 Update formData state
        setFormData((prev) => ({
          ...prev,
          signature: signaturePath,
        }));

        toast.success(<FormattedMessage id="validation.file_uploaded" />);
        return signaturePath;
      } else {
        console.log("NOT OK");
        return null;
      }
    } catch (error) {
      console.log("Error!", error);
      return null;
    }
  };

  const handleSubmit = async (jumpStep) => {
    let formDataObj = { ...formData };
    if (!validateStep()) {
      if (errorsObj.captcha) {
        toast.error(<FormattedMessage id="validation.captcha_required" />);
        return;
      } else {
        toast.warning(
          <FormattedMessage id="validation.fill_required_fields" />
        );
        return;
      }
    }

    setFormSaving(true);

    if (signature && !formDataObj.signature) {
      // Convert base64 to File (use dataURLtoFile from SignaturePad.js)
      const file = dataURLtoFile(signature, "signature.png");
      const uploadedSignature = await handleUpload(file);

      if (uploadedSignature) {
        formDataObj.signature = uploadedSignature;
      }
    }

    try {
      const fD = new FormData();
      formDataObj.child_use_toilet = JSON.stringify(
        formDataObj.child_use_toilet
      );

      if (step >= 7 && questions.length > 0) {
        const hasQAAnswers = Object.keys(formData.qaAnswers || {}).length > 0;
        if (hasQAAnswers) {
          const postData = getPostData();
          fD.append("answers", JSON.stringify(postData));
        }
      }

      fD.append(
        "admissioncountries",
        JSON.stringify(formDataObj.admissioncountries)
      );

      fD.append("formData", JSON.stringify(formDataObj));
      fD.append("picture", picture);
      fD.append("step", step);

      if (step === 1) {
        const captchaValue = recaptcha.current.getValue();
        fD.append("g-recaptcha-response", captchaValue);
      }

      health_declarations.length > 0 &&
        health_declarations.forEach((healthDeclaration) => {
          fD.append(
            `health_declarations[uuid][${healthDeclaration.uuid}]`,
            healthDeclaration.uuid
          );
          fD.append(
            `health_declarations[child_health_id][${healthDeclaration.uuid}]`,
            healthDeclaration.child_health_id
          );
          fD.append(
            `health_declarations[child_health_name][${healthDeclaration.uuid}]`,
            healthDeclaration.child_health_name
          );
          fD.append(
            `health_declarations[child_health_desc][${healthDeclaration.uuid}]`,
            healthDeclaration.child_health_desc
          );
          fD.append(
            `health_declarations[child_health_date][${healthDeclaration.uuid}]`,
            moment(healthDeclaration.child_health_date).format("YYYY-MM-DD")
          );
          fD.append(
            `health_declarations[child_health_type][${healthDeclaration.uuid}]`,
            healthDeclaration.child_health_type
          );
        });

      const response = await fetch(
        `${API_URL}/save-admission-data?tenant_id=f47ac10b58cc4372a5670e029j198745`,
        {
          method: "POST",
          body: fD,
        }
      );
      if (response.ok) {
        const { data, type, message } = await response.json();
        if (type) {
          const { admission, question_grps } = data;
          const { admission_id, admission_uuid } = admission;
          setQuestions(question_grps);
          setFormData((prevData) => ({
            ...prevData,
            admission_id,
          }));
          window.history.pushState(
            { aid: admission_id },
            "",
            `?aid=${admission_uuid}`
          );

          let stepNum = 0;

          if (step < steps.length && !jumpStep) {
            stepNum = step + 1;
            setStep(stepNum);
            setStepName(steps[stepNum - 1].name);
          } else if (jumpStep) {
            stepNum = jumpStep;
            setStep(stepNum);
            setStepName(steps[stepNum - 1].name);
          }

          toast.success(
            <FormattedMessage id="validation.saved_successfully" />
          );
        } else {
          if (message) {
            toast.info(message);
          }
          console.log("Error submitting form");
        }
      } else {
        console.log("Error submitting form");
      }
      setFormSaving(false);
    } catch (error) {
      setFormSaving(false);
      console.log("Something went wrong!");
      console.log(error);
    }
  };

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      <div id="page" dir={locale === "en" ? "ltr" : "rtl"}>
        <aside id="sidebar" className="d-none d-md-block position-relative">
          <small
            className="text-muted"
            style={{
              position: "absolute",
              bottom: 20,
              left: locale === "en" ? 20 : "auto",
              right: locale === "ar" ? 20 : "auto",
            }}
          >
            v{version}
          </small>
          <Row className="aside-header">
            <Col>
              <img src={require("./assets/twa.png")} alt="TWA" width="150" />
            </Col>
            <Col className="lang-switcher text-end">
              <ButtonGroup>
                <Button
                  size="sm"
                  onClick={handleLanguageChange}
                  value="en"
                  variant={locale === "en" ? "secondary" : "light"}
                >
                  EN
                </Button>
                <Button
                  size="sm"
                  onClick={handleLanguageChange}
                  value="ar"
                  variant={locale === "ar" ? "secondary" : "light"}
                >
                  AR
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <div className="steps-list">
            <ul>
              {steps.map((item, index) => (
                <li key={index} className={step === index + 1 ? "active" : ""}>
                  <Button
                    variant="link"
                    onClick={() => {
                      handleSubmit(index + 1);
                    }}
                  >
                    <FormattedMessage id={item.name} />
                  </Button>
                </li>
              ))}
            </ul>
          </div>
        </aside>
        <div id="content">
          <Row className="res-header d-md-none">
            <Col>
              <img src={require("./assets/twa.png")} alt="TWA" width="150" />
            </Col>
            <Col className="lang-switcher text-end">
              <ButtonGroup>
                <Button
                  size="sm"
                  onClick={handleLanguageChange}
                  value="en"
                  variant={locale === "en" ? "secondary" : "light"}
                >
                  EN
                </Button>
                <Button
                  size="sm"
                  onClick={handleLanguageChange}
                  value="ar"
                  variant={locale === "ar" ? "secondary" : "light"}
                >
                  AR
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <div id="content_child" className="position-relative">
            <div className="form-nav">
              <Button
                variant={step === steps.length ? "success" : "primary"}
                onClick={handleNextStep}
                disabled={
                  formSaving ||
                  (step === steps.length &&
                    (Number(formData?.check_acknowledgement) !== 1 ||
                      !signature))
                }
              >
                <FormattedMessage
                  id={step === steps.length ? "submit" : "next"}
                />
              </Button>
            </div>
            <h2 className="mb-3">
              <FormattedMessage id={stepName} />
            </h2>

            {/* STEP 1 */}
            {step === 1 && (
              <>
                <Row className="justify-content-end">
                  <Col md={2}>
                    <FilePicker
                      name="picture"
                      file={picture}
                      setFile={setPicture}
                      height={200}
                      error={errors?.picture}
                    />
                  </Col>
                  <Col md={2} className="d-flex align-items-center">
                    <FormattedMessage id="child_picture" />
                  </Col>
                  <Col
                    md={12}
                    xl={8}
                    className="ml-lg-auto d-flex flex-column flex-lg-row align-items-lg-center justify-content-lg-end gap-5 flex-column-reverse mt-5 lg:mt-3"
                  >
                    {/* <CenterDropdown
                      onSelectCenter={handleCenterSelect}
                      isEditMode={formData?.admission_id ? true : false}
                      selectedCenterId={formData?.center_id}
                      centers={centers}
                      error={errors?.center_id}
                    /> */}

                    <ReCAPTCHA
                      ref={recaptcha}
                      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                    />
                  </Col>
                </Row>

                {/* Child Details */}
                <SectionSeparator title="title.child_details" />
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="child_name">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.child_name}
                            placeholder={placeholder}
                            type="text"
                            name="child_name"
                            onChange={handleChange}
                            isInvalid={!!errors.child_name}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.child_name" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="child_middle_name">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.child_middle_name}
                            placeholder={placeholder}
                            type="text"
                            name="child_middle_name"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="child_family_name">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.child_family_name}
                            placeholder={placeholder}
                            type="text"
                            name="child_family_name"
                            onChange={handleChange}
                            isInvalid={!!errors.child_family_name}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.child_name" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="birth_date">
                        {(placeholder) => (
                          <DatePicker
                            placeholderText={placeholder}
                            className={
                              errors.birth_date
                                ? " form-control is-invalid"
                                : "form-control"
                            }
                            selected={formData.birth_date}
                            onChange={(date) =>
                              setFormData((prevData) => ({
                                ...prevData,
                                birth_date: date,
                              }))
                            }
                          />
                        )}
                      </FormattedMessage>
                      <div
                        className={errors.birth_date ? "is-invalid" : ""}
                      ></div>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.birth_date" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <Form.Select
                        name="gender"
                        onChange={handleChange}
                        value={formData.gender}
                        isInvalid={!!errors.gender}
                      >
                        <option value="">
                          <FormattedMessage id="select_gender" />
                        </option>
                        <option value="F">
                          <FormattedMessage id="female" />
                        </option>
                        <option value="M">
                          <FormattedMessage id="male" />
                        </option>
                      </Form.Select>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.gender" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <Form.Select
                        onChange={handleChange}
                        name="country_id"
                        value={formData.country_id}
                        isInvalid={!!errors.country_id}
                      >
                        <option value="">
                          <FormattedMessage id="select_nationality" />
                        </option>
                        {countries.map((country, index) => (
                          <option key={index} value={country.country_id}>
                            {country.name_en}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.country_id" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <Form.Select
                        onChange={handleChange}
                        name="religion"
                        value={formData.religion}
                        isInvalid={!!errors.religion}
                      >
                        <option value="">
                          <FormattedMessage id="select_religion" />
                        </option>
                        <option value="1">
                          <FormattedMessage id="other" />
                        </option>
                        <option value="2">
                          <FormattedMessage id="muslim" />
                        </option>
                        <option value="3">
                          <FormattedMessage id="christian" />
                        </option>
                      </Form.Select>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.religion" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="id_number">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.id_number}
                            placeholder={placeholder}
                            type="text"
                            name="id_number"
                            onChange={handleChange}
                            isInvalid={!!errors.id_number}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.id_number" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                                      <Form.Group className="mb-4">
                                        <FormattedMessage id="home_address">
                                          {(placeholder) => (
                                            <Form.Control
                                              value={formData.home_address}
                                              placeholder={placeholder}
                                              as="textarea"
                                              rows={3}
                                              name="home_address"
                                              onChange={handleChange}
                                            />
                                          )}
                                        </FormattedMessage>
                                      </Form.Group>
                                    </Col>
                  {/* <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <Form.Select
                        name="agegroup_id"
                        onChange={handleChange}
                        value={formData.agegroup_id}
                        isInvalid={!!errors.agegroup_id}
                      >
                        <option value="">
                          <FormattedMessage id="agegroup_id" />
                        </option>
                        {ageGroup?.map((language, index) => (
                          <option key={index} value={language.agegroup_id}>
                            {language.agegroup_code}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.agegroup_id" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col> */}
                </Row>

                {/* Family Details */}
                <SectionSeparator title="title.family_details" />
                <SubSectionSeparator title="title.sponsor_parent_information" />
                <Row>
                  {/* <Col md={3}>
                    <Form.Group className="mb-4">
                      <ToggleButtonGroup
                        type="radio"
                        name="sponsor_role"
                        value={formData.sponsor_role}
                        onChange={(val) =>
                          setFormData({ ...formData, sponsor_role: val })
                        }
                        isInvalid={!!errors.sponsor_role}
                        className="w-100"
                      >
                        <ToggleButton
                          id="sponsor-father-toggle"
                          value="Father"
                          variant="outline-primary"
                          className="first-btn"
                        >
                          <FormattedMessage
                            id="father"
                            defaultMessage="Father"
                          />
                        </ToggleButton>
                        <ToggleButton
                          id="sponsor-mother-toggle"
                          value="Mother"
                          variant="outline-primary"
                          className="second-btn"
                        >
                          <FormattedMessage
                            id="mother"
                            defaultMessage="Mother"
                          />
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </Form.Group>
                  </Col> */}

                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="full_name">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.father_name}
                            placeholder={placeholder}
                            type="text"
                            name="father_name"
                            onChange={handleChange}
                            isInvalid={!!errors.father_name}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.full_name" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="mobile_number">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.father_mobile}
                            placeholder={placeholder}
                            type="text"
                            name="father_mobile"
                            onChange={handleChange}
                            isInvalid={!!errors.father_mobile}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.mobile" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="work_number">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.father_workphone}
                            placeholder={placeholder}
                            type="text"
                            name="father_workphone"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="email_address">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.father_email}
                            placeholder={placeholder}
                            type="text"
                            name="father_email"
                            onChange={handleChange}
                            isInvalid={!!errors.father_email}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.email" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="place_of_work">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.father_employer}
                            placeholder={placeholder}
                            type="text"
                            name="father_employer"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="occupation">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.father_position}
                            placeholder={placeholder}
                            type="text"
                            name="father_position"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  {/* <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="home_address">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.home_address}
                            placeholder={placeholder}
                            type="text"
                            name="home_address"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col> */}
                </Row>

                <SubSectionSeparator title="title.spouse_information" />
                <Row>
                  {/* <Col md={3}>
                    <Form.Group className="mb-4">
                      <ToggleButtonGroup
                        type="radio"
                        name="spouse_role"
                        value={formData.spouse_role}
                        onChange={(val) =>
                          setFormData({ ...formData, spouse_role: val })
                        }
                        isInvalid={!!errors.spouse_role}
                        className="w-100"
                      >
                        <ToggleButton
                          id="spouse-father-toggle"
                          value="Father"
                          variant="outline-primary"
                          className="first-btn"
                        >
                          <FormattedMessage
                            id="father"
                            defaultMessage="Father"
                          />
                        </ToggleButton>
                        <ToggleButton
                          id="spouse-mother-toggle"
                          value="Mother"
                          variant="outline-primary"
                          className="second-btn"
                        >
                          <FormattedMessage
                            id="mother"
                            defaultMessage="Mother"
                          />
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </Form.Group>
                  </Col> */}
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="full_name">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.mother_name}
                            placeholder={placeholder}
                            type="text"
                            name="mother_name"
                            onChange={handleChange}
                            isInvalid={!!errors.mother_name}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.full_name" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="mobile_number">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.mother_mobile}
                            placeholder={placeholder}
                            type="text"
                            name="mother_mobile"
                            onChange={handleChange}
                            isInvalid={!!errors.mother_mobile}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.mobile" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="work_number">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.mother_workphone}
                            placeholder={placeholder}
                            type="text"
                            name="mother_workphone"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="email_address">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.mother_email}
                            placeholder={placeholder}
                            type="text"
                            name="mother_email"
                            onChange={handleChange}
                            isInvalid={!!errors.mother_email}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.email" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="place_of_work">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.mother_employer}
                            placeholder={placeholder}
                            type="text"
                            name="mother_employer"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="occupation">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.mother_position}
                            placeholder={placeholder}
                            type="text"
                            name="mother_position"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                </Row>

                <SubSectionSeparator title="title.sibling_information" />
                <Row>
                  <Col md={4}>
                    <Form.Group className="mb-4 position-relative">
                      <FormattedMessage id="sibling_name">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.child_siblings}
                            placeholder={placeholder}
                            type="text"
                            name="child_siblings"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="sibling_age">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.child_siblings_age}
                            placeholder={placeholder}
                            type="text"
                            name="child_siblings_age"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="school_attending">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.child_school_attending}
                            placeholder={placeholder}
                            type="text"
                            name="child_school_attending"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                </Row>

                <SectionSeparator title="title.emergency_contact" />
                <Row>
                  <Col md={4}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="name">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.emergency_contact1}
                            placeholder={placeholder}
                            type="text"
                            name="emergency_contact1"
                            onChange={handleChange}
                            isInvalid={!!errors.emergency_contact1}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.emergency_contact_name" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="relation">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.emergency_relation1}
                            placeholder={placeholder}
                            type="text"
                            name="emergency_relation1"
                            onChange={handleChange}
                            isInvalid={!!errors.emergency_relation1}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.emergency_contact_relation" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="contact_number">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.emergency_phone1}
                            placeholder={placeholder}
                            type="text"
                            name="emergency_phone1"
                            onChange={handleChange}
                            isInvalid={!!errors.emergency_phone1}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.emergency_contact_number" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <SectionSeparator title="title.admission_countries" />

                <AdmissionCountries
                  admissioncountries={formData.admissioncountries}
                  errors={errors}
                  setFormData={setFormData}
                />
              </>
            )}

            {/* STEP 2 */}
            {step === 2 && (
              <>
                {/* Child's Documents */}
                <SectionSeparator title="title.child_documents" />
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="emirates_id_front" />
                        <span className="required-field-without-position">
                          *
                        </span>
                      </Form.Label>
                      <FilePicker
                        name="child_eid_page"
                        file={child_eid_page}
                        setFile={setChildEidPage}
                        admissionID={formData.admission_id}
                        center_uuid={center_uuid}
                        height={200}
                        uploadable
                        error={errors?.child_eid_page}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="emirates_id_back" />
                        <span className="required-field-without-position">
                          *
                        </span>
                      </Form.Label>
                      <FilePicker
                        name="child_eid_page_back"
                        file={child_eid_page_back}
                        setFile={setChildEidPageBack}
                        admissionID={formData.admission_id}
                        center_uuid={center_uuid}
                        height={200}
                        uploadable
                        error={errors?.child_eid_page_back}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="passport" />
                        <span className="required-field-without-position">
                          *
                        </span>
                      </Form.Label>
                      <FilePicker
                        name="child_passport"
                        file={child_passport}
                        setFile={setChildPassport}
                        admissionID={formData.admission_id}
                        center_uuid={center_uuid}
                        height={200}
                        uploadable
                        error={errors?.child_passport}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="birth_certificate" />
                        <span className="required-field-without-position">
                          *
                        </span>
                      </Form.Label>
                      <FilePicker
                        name="birth_certcopy"
                        file={birth_certcopy}
                        setFile={setBirthCertcopy}
                        admissionID={formData.admission_id}
                        center_uuid={center_uuid}
                        height={200}
                        uploadable
                        error={errors?.birth_certcopy}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="immunization_record" />
                        <span className="required-field-without-position">
                          *
                        </span>
                      </Form.Label>
                      <FilePicker
                        name="vaccination_copy"
                        file={vaccination_copy}
                        setFile={setVaccinationCopy}
                        admissionID={formData.admission_id}
                        center_uuid={center_uuid}
                        height={200}
                        uploadable
                        error={errors?.vaccination_copy}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="medical_insurance_record" />
                      </Form.Label>
                      <FilePicker
                        name="med_formcopy"
                        file={med_formcopy}
                        setFile={setMedFormcopy}
                        admissionID={formData.admission_id}
                        center_uuid={center_uuid}
                        height={200}
                        uploadable
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="visa" />
                      </Form.Label>
                      <FilePicker
                        name="visa_page"
                        file={visa_page}
                        setFile={setVisaPage}
                        admissionID={formData.admission_id}
                        center_uuid={center_uuid}
                        height={200}
                        uploadable
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="attended_prev_school_report" />
                      </Form.Label>
                      <FilePicker
                        name="prev_school_rep_doc"
                        file={prev_school_rep_doc}
                        setFile={setPrevSchoolRepCopy}
                        admissionID={formData.admission_id}
                        center_uuid={center_uuid}
                        height={200}
                        uploadable
                        // error={errors?.prev_school_rep_doc}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="document1" />
                      </Form.Label>
                      <FilePicker
                        name="document1"
                        file={document1}
                        setFile={setDocument1}
                        admissionID={formData.admission_id}
                        center_uuid={center_uuid}
                        height={200}
                        uploadable
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* Sponsor's Documents */}
                <SectionSeparator title="title.sponsor_documents" />
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="emirates_id_front" />
                        <span className="required-field-without-position">
                          *
                        </span>
                      </Form.Label>
                      <FilePicker
                        name="father_id_attachment"
                        file={father_id_attachment}
                        setFile={setFatherIdAttachment}
                        admissionID={formData.admission_id}
                        center_uuid={center_uuid}
                        height={200}
                        uploadable
                        error={errors?.father_id_attachment}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="emirates_id_back" />
                        <span className="required-field-without-position">
                          *
                        </span>
                      </Form.Label>
                      <FilePicker
                        name="father_id_attachment_back"
                        file={father_id_attachment_back}
                        setFile={setFatherIdAttachmentBack}
                        admissionID={formData.admission_id}
                        center_uuid={center_uuid}
                        height={200}
                        uploadable
                        error={errors?.father_id_attachment_back}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="passport" />
                        <span className="required-field-without-position">
                          *
                        </span>
                      </Form.Label>
                      <FilePicker
                        name="father_passport_attachment"
                        file={father_passport_attachment}
                        setFile={setFatherPassportAttachment}
                        admissionID={formData.admission_id}
                        center_uuid={center_uuid}
                        height={200}
                        uploadable
                        error={errors?.father_passport_attachment}
                      />
                    </Form.Group>
                  </Col>
                  {/* <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      <FormattedMessage id="visa" />
                    </Form.Label>
                    <FilePicker
                      name="father_visa_attachment"
                      file={father_visa_attachment}
                      setFile={setFatherVisaAttachment}
                      admissionID={formData.admission_id}
                      height={200}
                      uploadable
                    />
                  </Form.Group>
                </Col> */}
                </Row>

                {/* Spouse's Documents */}
                <SectionSeparator title="title.spouse_documents" />
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="emirates_id_front" />
                        <span className="required-field-without-position">
                          *
                        </span>
                      </Form.Label>
                      <FilePicker
                        name="mother_id_attachment"
                        file={mother_id_attachment}
                        setFile={setMotherIdAttachment}
                        admissionID={formData.admission_id}
                        center_uuid={center_uuid}
                        height={200}
                        uploadable
                        error={errors?.mother_id_attachment}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="emirates_id_back" />
                        <span className="required-field-without-position">
                          *
                        </span>
                      </Form.Label>
                      <FilePicker
                        name="mother_id_attachment_back"
                        file={mother_id_attachment_back}
                        setFile={setMotherIdAttachmentBack}
                        admissionID={formData.admission_id}
                        center_uuid={center_uuid}
                        height={200}
                        uploadable
                        error={errors?.mother_id_attachment_back}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="passport" />
                        <span className="required-field-without-position">
                          *
                        </span>
                      </Form.Label>
                      <FilePicker
                        name="mother_passport_attachment"
                        file={mother_passport_attachment}
                        setFile={setMotherPassportAttachment}
                        admissionID={formData.admission_id}
                        center_uuid={center_uuid}
                        height={200}
                        uploadable
                        error={errors?.mother_passport_attachment}
                      />
                    </Form.Group>
                  </Col>
                  {/* <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      <FormattedMessage id="visa" />
                    </Form.Label>
                    <FilePicker
                      name="mother_visa_attachment"
                      file={mother_visa_attachment}
                      setFile={setMotherVisaAttachment}
                      admissionID={formData.admission_id}
                      height={200}
                      uploadable
                    />
                  </Form.Group>
                </Col> */}
                </Row>
              </>
            )}

            {/* STEP 9 */}
            {step === 9 && (
              <>
                <SectionSeparator title="title.about_your_child" />
                <Row>
                  <Col md={4}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="position_in_family" />
                      </Form.Label>
                      <Form.Select
                        name="child_position_family"
                        onChange={handleChange}
                        value={formData.child_position_family}
                      >
                        <option value="1st Child">
                          <FormattedMessage id="1st_child" />
                        </option>
                        <option value="2nd Child">
                          <FormattedMessage id="2nd_child" />
                        </option>
                        <option value="3rd Child">
                          <FormattedMessage id="3rd_child" />
                        </option>
                        <option value="4th Child">
                          <FormattedMessage id="4th_child" />
                        </option>
                        <option value="5th Child">
                          <FormattedMessage id="5th_child" />
                        </option>
                        <option value="Other">
                          <FormattedMessage id="other" />
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="1st_language" />
                      </Form.Label>
                      <Form.Select
                        name="first_lang"
                        onChange={handleChange}
                        value={formData.first_lang}
                      >
                        <option value=""></option>
                        {languages.map((language, index) => (
                          <option key={index} value={language.lang_name}>
                            {language.lang_name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="2nd_language" />
                      </Form.Label>
                      <Form.Select
                        name="second_lang"
                        onChange={handleChange}
                        value={formData.second_lang}
                      >
                        <option value=""></option>
                        {languages.map((language, index) => (
                          <option key={index} value={language.lang_name}>
                            {language.lang_name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="additional_requirements" />
                      </Form.Label>
                      <Form.Control
                        value={formData.child_religion_food_clothing_desc}
                        type="text"
                        name="child_religion_food_clothing_desc"
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="attending_other_settings" />
                      </Form.Label>
                      <Form.Select
                        name="child_prev_settings"
                        onChange={handleChange}
                        className="w-md-50"
                        value={formData.child_prev_settings}
                      >
                        <option value=""></option>
                        <option value="Parents & Toddlers">
                          <FormattedMessage id="parents_toddlers" />
                        </option>
                        <option value="Playground">
                          <FormattedMessage id="playground" />
                        </option>
                        <option value="Private Nursery">
                          <FormattedMessage id="private_nursery" />
                        </option>
                        <option value="Nanny">
                          <FormattedMessage id="nanny" />
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

                <SectionSeparator title="title.dietary_requirements" />
                <Row>
                  <Col md={4}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="child_milk" />
                      </Form.Label>
                      <Form.Select
                        name="child_diet_milktype"
                        onChange={handleChange}
                        value={formData.child_diet_milktype}
                      >
                        <option value="Not Applicable">
                          <FormattedMessage id="not_applicable" />
                        </option>
                        <option value="Whole Cows">
                          <FormattedMessage id="cow" />
                        </option>
                        <option value="Low Fat">
                          <FormattedMessage id="low_fat" />
                        </option>
                        <option value="Lacoste Free">
                          <FormattedMessage id="lacoste_free" />
                        </option>
                        <option value="Soy Milk">
                          <FormattedMessage id="soy_milk" />
                        </option>
                        <option value="Almond Milk">
                          <FormattedMessage id="almond_milk" />
                        </option>
                        <option value="Breast">
                          <FormattedMessage id="breast" />
                        </option>
                        <option value="Formula">
                          <FormattedMessage id="formula" />
                        </option>
                        <option value="Other">
                          <FormattedMessage id="other" />
                        </option>
                        <option value="No Milk">
                          <FormattedMessage id="no_milk" />
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={8}></Col>
                  <Col md={6}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="cow_milk_quantity" />
                      </Form.Label>
                      <FormattedMessage id="please_specify">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.child_diet_milktype_preparation}
                            placeholder={placeholder}
                            type="text"
                            name="child_diet_milktype_preparation"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="quantity_ml" />{" "}
                        <strong>({formData.child_diet_milktype_qty})</strong>
                      </Form.Label>
                      <Form.Range
                        name="child_diet_milktype_qty"
                        min={1}
                        max={200}
                        value={formData.child_diet_milktype_qty}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="frequency" />{" "}
                        <strong>({formData.child_diet_milktype_freq})</strong>
                      </Form.Label>
                      <Form.Range
                        name="child_diet_milktype_freq"
                        min={1}
                        max={10}
                        value={formData.child_diet_milktype_freq}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  {/* <Col md={6}>
                  <Form.Group className="mb-4">
                    <Form.Label>
                      <FormattedMessage id="weaning_foods" />
                    </Form.Label>
                    <FormattedMessage id="please_specify">
                      {(placeholder) => (
                        <Form.Control
                          value={formData.child_weaningfood}
                          placeholder={placeholder}
                          type="text"
                          name="child_weaningfood"
                          onChange={handleChange}
                        />
                      )}
                    </FormattedMessage>
                  </Form.Group>
                </Col> 
                <Col md={3}>
                  <Form.Group className="mb-4">
                    <Form.Label>
                      <FormattedMessage id="volume" />{" "}
                      <strong>({formData.child_weaningfood_volume})</strong>
                    </Form.Label>
                    <Form.Range
                      name="child_weaningfood_volume"
                      min={1}
                      max={200}
                      value={formData.child_weaningfood_volume}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group className="mb-4">
                    <Form.Label>
                      <FormattedMessage id="frequency" />{" "}
                      <strong>({formData.child_weaningfood_freq})</strong>
                    </Form.Label>
                    <Form.Range
                      name="child_weaningfood_freq"
                      min={1}
                      max={10}
                      value={formData.child_weaningfood_freq}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>*/}
                  {/* <Col md={12}>
                  <Form.Label>
                    <FormattedMessage id="types_of_food" />
                  </Form.Label>
                </Col>
                <Col md={4} className="mb-4">
                  <FormattedMessage id="snacks">
                    {(placeholder) => (
                      <Form.Control
                        value={formData.child_weaningfood_snack}
                        placeholder={placeholder}
                        type="text"
                        name="child_weaningfood_snack"
                        onChange={handleChange}
                      />
                    )}
                  </FormattedMessage>
                </Col> */}
                  <Col md={4} className="mb-4">
                    <FormattedMessage id="main_course">
                      {(placeholder) => (
                        <Form.Control
                          value={formData.child_weaningfood_maincourse}
                          placeholder={placeholder}
                          type="text"
                          name="child_weaningfood_maincourse"
                          onChange={handleChange}
                        />
                      )}
                    </FormattedMessage>
                  </Col>
                  <Col md={4} className="mb-4">
                    <FormattedMessage id="puddings">
                      {(placeholder) => (
                        <Form.Control
                          value={formData.child_weaningfood_puddings}
                          placeholder={placeholder}
                          type="text"
                          name="child_weaningfood_puddings"
                          onChange={handleChange}
                        />
                      )}
                    </FormattedMessage>
                  </Col>
                </Row>
                <SectionSeparator title="title.sleeping_patterns" />
                <Row>
                  <Col md={4}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="child_sleep_time" />
                      </Form.Label>
                      <Form.Control
                        value={formData.child_sleep_time}
                        type="time"
                        name="child_sleep_time"
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="child_sleep_hours" />{" "}
                        <strong>({formData.child_sleep_mins})</strong>
                      </Form.Label>
                      <Form.Range
                        name="child_sleep_mins"
                        min={1}
                        max={24}
                        value={formData.child_sleep_mins}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="special_comforters" />
                      </Form.Label>
                      <Form.Control
                        value={formData.child_sleep_comforters}
                        type="text"
                        name="child_sleep_comforters"
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <SectionSeparator title="title.personal_development" />
                <Row>
                  <Col md={12}>
                    <Form.Label>
                      <FormattedMessage id="daily_hygiene_and_habits" />
                    </Form.Label>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-4">
                      <Form.Select
                        name="child_use_toilet_0"
                        onChange={handleChange}
                        value={formData.child_use_toilet[0]}
                      >
                        <option value="Select">
                          <FormattedMessage id="select" />
                        </option>
                        <option value="Unaided">
                          <FormattedMessage id="unaided" />
                        </option>
                        <option value="Requires Assistance">
                          <FormattedMessage id="requires_assistance" />
                        </option>
                        <option value="Requires Reminding">
                          <FormattedMessage id="requires_reminding" />
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-4">
                      <Form.Select
                        name="child_use_toilet_1"
                        onChange={handleChange}
                        value={formData.child_use_toilet[1]}
                      >
                        <option value="Select">
                          <FormattedMessage id="select" />
                        </option>
                        <option value="In Nappies">
                          <FormattedMessage id="in_nappies" />
                        </option>
                        <option value="In Pull-Ups">
                          <FormattedMessage id="in_pull_ups" />
                        </option>
                        <option value="None">
                          <FormattedMessage id="none" />
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-4">
                      <Form.Select
                        name="child_use_toilet_2"
                        onChange={handleChange}
                        value={formData.child_use_toilet[2]}
                      >
                        <option value="Select">
                          <FormattedMessage id="select" />
                        </option>
                        <option value="Able to wash own hands">
                          <FormattedMessage id="able_to_wash_own_hands" />
                        </option>
                        <option value="Not able to wash own hands">
                          <FormattedMessage id="not_able_to_wash_own_hands" />
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="child_spoon_knife_fork" />
                      </Form.Label>
                      <Form.Select
                        name="child_use_cutlery"
                        onChange={handleChange}
                        value={formData.child_use_cutlery}
                      >
                        <option value="Select">
                          <FormattedMessage id="select" />
                        </option>
                        <option value="Unaided">
                          <FormattedMessage id="unaided" />
                        </option>
                        <option value="Requires Assistance">
                          <FormattedMessage id="requires_assistance" />
                        </option>
                        <option value="No">
                          <FormattedMessage id="no" />
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="child_drink_open_cup" />
                      </Form.Label>
                      <br />
                      <ButtonGroup>
                        <Button
                          size="sm"
                          name="child_use_drinkcup"
                          onClick={handleChange}
                          value="1"
                          variant={
                            formData.child_use_drinkcup == 1
                              ? "secondary"
                              : "light"
                          }
                        >
                          <FormattedMessage id="yes" />
                        </Button>
                        <Button
                          size="sm"
                          name="child_use_drinkcup"
                          onClick={handleChange}
                          value="0"
                          variant={
                            formData.child_use_drinkcup == 0
                              ? "secondary"
                              : "light"
                          }
                        >
                          <FormattedMessage id="no" />
                        </Button>
                      </ButtonGroup>
                    </Form.Group>
                  </Col>
                </Row>

                <SectionSeparator title="title.emotional_development" />
                <Row>
                  <Col md={4}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="child_relate_other_children" />
                      </Form.Label>
                      <br />
                      <ButtonGroup>
                        <Button
                          size="sm"
                          name="child_relate_children"
                          onClick={handleChange}
                          value="1"
                          variant={
                            formData.child_relate_children == 1
                              ? "secondary"
                              : "light"
                          }
                        >
                          <FormattedMessage id="yes" />
                        </Button>
                        <Button
                          size="sm"
                          name="child_relate_children"
                          onClick={handleChange}
                          value="0"
                          variant={
                            formData.child_relate_children == 0
                              ? "secondary"
                              : "light"
                          }
                        >
                          <FormattedMessage id="no" />
                        </Button>
                      </ButtonGroup>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="child_relate_familiar_adults" />
                      </Form.Label>
                      <br />
                      <ButtonGroup>
                        <Button
                          size="sm"
                          name="child_relate_familiar_adults"
                          onClick={handleChange}
                          value="1"
                          variant={
                            formData.child_relate_familiar_adults == 1
                              ? "secondary"
                              : "light"
                          }
                        >
                          <FormattedMessage id="yes" />
                        </Button>
                        <Button
                          size="sm"
                          name="child_relate_familiar_adults"
                          onClick={handleChange}
                          value="0"
                          variant={
                            formData.child_relate_familiar_adults == 0
                              ? "secondary"
                              : "light"
                          }
                        >
                          <FormattedMessage id="no" />
                        </Button>
                      </ButtonGroup>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="child_share_take_turns" />
                      </Form.Label>
                      <br />
                      <ButtonGroup>
                        <Button
                          size="sm"
                          name="child_take_turns"
                          onClick={handleChange}
                          value="1"
                          variant={
                            formData.child_take_turns == 1
                              ? "secondary"
                              : "light"
                          }
                        >
                          <FormattedMessage id="yes" />
                        </Button>
                        <Button
                          size="sm"
                          name="child_take_turns"
                          onClick={handleChange}
                          value="0"
                          variant={
                            formData.child_take_turns == 0
                              ? "secondary"
                              : "light"
                          }
                        >
                          <FormattedMessage id="no" />
                        </Button>
                      </ButtonGroup>
                    </Form.Group>
                  </Col>
                </Row>

                <SectionSeparator title="title.enjoyment_curiosity" />
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="describe_your_child" />
                      </Form.Label>
                      <Form.Control
                        value={formData.notes}
                        type="text"
                        name="notes"
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="child_favorite_toys" />
                      </Form.Label>
                      <Form.Control
                        value={formData.child_toys}
                        type="text"
                        name="child_toys"
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="child_activities" />
                      </Form.Label>
                      <Form.Control
                        value={formData.child_activities}
                        type="text"
                        name="child_activities"
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="child_distress" />
                      </Form.Label>
                      <Form.Control
                        value={formData.child_distress}
                        type="text"
                        name="child_distress"
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="child_extra_info" />
                      </Form.Label>
                      <Form.Control
                        value={formData.child_extra_info}
                        type="text"
                        name="child_extra_info"
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}

            {/* STEP 3 */}
            {step === 3 && (
              <>
                <SubSectionSeparator title="visual_media_consent" />
                <Row>
                  <Col md={12}>
                    <Form.Group className="mb-4">
                      <ButtonGroup className="me-3 ms-0">
                        <Button
                          size="sm"
                          name="pic_nursery"
                          onClick={handleChange}
                          value="1"
                          variant={
                            formData.pic_nursery == 1 ? "secondary" : "light"
                          }
                        >
                          <FormattedMessage id="yes" />
                        </Button>
                        <Button
                          size="sm"
                          name="pic_nursery"
                          onClick={handleChange}
                          value="0"
                          variant={
                            formData.pic_nursery == 0 ? "secondary" : "light"
                          }
                        >
                          <FormattedMessage id="no" />
                        </Button>
                      </ButtonGroup>
                      <Form.Label>
                        <FormattedMessage id="social_media_website" />
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className="mb-4">
                      <ButtonGroup className="me-3 ms-0">
                        <Button
                          size="sm"
                          name="pic_media"
                          onClick={handleChange}
                          value="1"
                          variant={
                            formData.pic_media == 1 ? "secondary" : "light"
                          }
                        >
                          <FormattedMessage id="yes" />
                        </Button>
                        <Button
                          size="sm"
                          name="pic_media"
                          onClick={handleChange}
                          value="0"
                          variant={
                            formData.pic_media == 0 ? "secondary" : "light"
                          }
                        >
                          <FormattedMessage id="no" />
                        </Button>
                      </ButtonGroup>
                      <Form.Label>
                        <FormattedMessage id="advertising" />
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className="mb-4">
                      <ButtonGroup className="me-3 ms-0">
                        <Button
                          size="sm"
                          name="pic_social"
                          onClick={handleChange}
                          value="1"
                          variant={
                            formData.pic_social == 1 ? "secondary" : "light"
                          }
                        >
                          <FormattedMessage id="yes" />
                        </Button>
                        <Button
                          size="sm"
                          name="pic_social"
                          onClick={handleChange}
                          value="0"
                          variant={
                            formData.pic_social == 0 ? "secondary" : "light"
                          }
                        >
                          <FormattedMessage id="no" />
                        </Button>
                      </ButtonGroup>
                      <Form.Label>
                        <FormattedMessage id="printing" />
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className="mb-4">
                      <ButtonGroup className="me-3 ms-0">
                        <Button
                          size="sm"
                          name="take_pictures"
                          onClick={handleChange}
                          value="1"
                          variant={
                            formData.take_pictures == 1 ? "secondary" : "light"
                          }
                        >
                          <FormattedMessage id="yes" />
                        </Button>
                        <Button
                          size="sm"
                          name="take_pictures"
                          onClick={handleChange}
                          value="0"
                          variant={
                            formData.take_pictures == 0 ? "secondary" : "light"
                          }
                        >
                          <FormattedMessage id="no" />
                        </Button>
                      </ButtonGroup>
                      <Form.Label>
                        <FormattedMessage id="educore_app" />
                      </Form.Label>
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}

            {/* STEP 4 */}
            {step === 4 && (
              <>
                <SectionSeparator title="title.medical_emergency" />
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="medical_emergency_name">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.medical_emergency_name}
                            placeholder={placeholder}
                            type="text"
                            name="medical_emergency_name"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="medical_emergency_doc">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.medical_emergency_doc}
                            placeholder={placeholder}
                            type="text"
                            name="medical_emergency_doc"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="medical_emergency_clinic">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.medical_emergency_clinic}
                            placeholder={placeholder}
                            type="text"
                            name="medical_emergency_clinic"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="medical_emergency_phone">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.medical_emergency_phone}
                            placeholder={placeholder}
                            type="text"
                            name="medical_emergency_phone"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                </Row>

                {/* Chronic Illnesses */}
                <SectionSeparator title="title.health_declaration_form" />
                <Row>
                  <Col md={12}>
                    {" "}
                    <Form.Label>
                      <FormattedMessage id="chronic_illness" />
                    </Form.Label>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <Form.Select
                        onChange={(e) => setChronicIllness(e.target.value)}
                        value={chronicIllness}
                        isInvalid={!!errors.chronicIllness}
                      >
                        <option value="">
                          <FormattedMessage id="select" />
                        </option>
                        {chronicIllnesses.map((illness, index) => (
                          <option key={index} value={illness}>
                            {illness}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={5}>
                    <FormattedMessage id="info_treatments_medications">
                      {(placeholder) => (
                        <Form.Control
                          value={chronicIllnessDesc}
                          placeholder={placeholder}
                          type="text"
                          onChange={(e) =>
                            setChronicIllnessDesc(e.target.value)
                          }
                          isInvalid={!!errors.chronicIllness}
                        />
                      )}
                    </FormattedMessage>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="date">
                        {(placeholder) => (
                          <DatePicker
                            placeholderText={placeholder}
                            className={"form-control"}
                            selected={chronicIllnessDate}
                            onChange={(date) => setChronicIllnessDate(date)}
                            isInvalid={!!errors.chronicIllness}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={1} className="ps-4">
                    <Button
                      variant="success"
                      size="sm"
                      onClick={() => addHealthDeclaration("Chronic Illness")}
                    >
                      <FiPlus />
                    </Button>
                  </Col>
                  <Col md={12}>
                    {errors.chronicIllness && (
                      <Form.Group className="mb-4 position-relative">
                        <Form.Control.Feedback
                          className="px-3 d-block"
                          type="invalid"
                        >
                          <FormattedMessage id="error.chronicIllness" />
                        </Form.Control.Feedback>
                      </Form.Group>
                    )}
                  </Col>
                </Row>

                {health_declarations
                  .filter(
                    (healthDeclaration) =>
                      healthDeclaration.child_health_type === "Chronic Illness"
                  )
                  .map((healthDeclaration, index) => (
                    <Row key={index} className="mb-3">
                      <Col md={3} className="ps-4">
                        {healthDeclaration.child_health_name}
                      </Col>
                      <Col md={5} className="ps-4">
                        {healthDeclaration.child_health_desc}
                      </Col>
                      <Col md={3} className="ps-4">
                        {moment(healthDeclaration.child_health_date).format(
                          "DD/MM/YYYY"
                        )}
                      </Col>
                      <Col md={1} className="ps-4">
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() =>
                            removeHealthDeclaration(healthDeclaration.uuid)
                          }
                        >
                          <FiMinus />
                        </Button>
                      </Col>
                    </Row>
                  ))}

                <SectionSeparator title="title.bloodgroup" />
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="bloodgroup">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.bloodgroup}
                            placeholder={placeholder}
                            type="text"
                            name="bloodgroup"
                            onChange={handleChange}
                            isInvalid={!!errors.bloodgroup}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.bloodgroup" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}

            {/* STEP 5 */}
            {step === 5 && (
              <>
                <SectionSeparator title="title.food_other_allergy" />
                <Row>
                  <Col md={12} className="mb-4">
                    <Row>
                      <Col md={2}>
                        <Form.Label style={{ paddingTop: 3, marginBottom: 11 }}>
                          <FormattedMessage id="known_allergies" />
                          <span className="required-field-without-position">
                            *
                          </span>
                        </Form.Label>
                      </Col>
                      {/* <Col md={1} style={{ paddingTop: 3 }}>
                      <ButtonGroup className="mx-3">
                        <Button
                          size="sm"
                          name="leela_allergies_button"
                          value="Yes"
                          variant={
                            otherAllergiesButtonValue.leela_allergies_button ===
                            "Yes"
                              ? "secondary"
                              : "light"
                          }
                          onClick={handleButtonClick}
                        >
                          <FormattedMessage id="yes" />
                        </Button>
                        <Button
                          size="sm"
                          name="leela_allergies_button"
                          value="No"
                          variant={
                            otherAllergiesButtonValue.leela_allergies_button ===
                            "No"
                              ? "secondary"
                              : "light"
                          }
                          onClick={handleButtonClick}
                        >
                          <FormattedMessage id="no" />
                        </Button>
                      </ButtonGroup>
                    </Col> */}
                      <Col md={9} className="ps-4">
                        <Form.Group className="position-relative">
                          <Form.Select
                            name="leela_allergies"
                            onChange={handleChange}
                            value={formData.leela_allergies}
                            isInvalid={!!errors.leela_allergies}
                          >
                            <option value="">
                              <FormattedMessage id="select" />
                            </option>
                            {allergyOptions.map((illness, index) => (
                              <option key={index} value={illness}>
                                {illness}
                              </option>
                            ))}
                          </Form.Select>
                          <Form.Control.Feedback
                            className="px-3"
                            type="invalid"
                          >
                            <FormattedMessage id="error.leela_allergies" />
                          </Form.Control.Feedback>
                        </Form.Group>
                        {/* <FormattedMessage id="if_yes_please_specify">
                          {(placeholder) => (
                            <Form.Control
                              value={formData.leela_allergies}
                              placeholder={placeholder}
                              type="text"
                              name="leela_allergies"
                              onChange={handleChange}
                            />
                          )}
                        </FormattedMessage> */}
                      </Col>
                    </Row>
                  </Col>
                  <Col md={12} className="mb-4">
                    <Row>
                      <Col md={2}>
                        <Form.Label style={{ paddingTop: 3, marginBottom: 11 }}>
                          <FormattedMessage id="dietary_intolerance" />
                        </Form.Label>
                      </Col>
                      {/* <Col md={1} style={{ paddingTop: 3 }}>
                      <ButtonGroup className="mx-3">
                        <Button
                          size="sm"
                          name="leela_dietry_intolerances_button"
                          onClick={handleButtonClick}
                          value="Yes"
                          variant={
                            otherAllergiesButtonValue.leela_dietry_intolerances_button ===
                            "Yes"
                              ? "secondary"
                              : "light"
                          }
                        >
                          <FormattedMessage id="yes" />
                        </Button>
                        <Button
                          size="sm"
                          name="leela_dietry_intolerances_button"
                          onClick={handleButtonClick}
                          value="No"
                          variant={
                            otherAllergiesButtonValue.leela_dietry_intolerances_button ===
                            "No"
                              ? "secondary"
                              : "light"
                          }
                        >
                          <FormattedMessage id="no" />
                        </Button>
                      </ButtonGroup>
                    </Col> */}
                      <Col md={9} className="ps-4">
                        {/* {otherAllergiesButtonValue.leela_dietry_intolerances_button ===
                        "Yes" && ( */}
                        <FormattedMessage id="dietary_intolerance">
                          {(placeholder) => (
                            <Form.Control
                              value={formData.leela_dietry_intolerances}
                              placeholder={placeholder}
                              type="text"
                              name="leela_dietry_intolerances"
                              onChange={handleChange}
                            />
                          )}
                        </FormattedMessage>
                        {/* )} */}
                      </Col>
                    </Row>
                  </Col>
                  <Col md={12} className="mb-4">
                    <Row>
                      <Col md={2}>
                        <Form.Label style={{ paddingTop: 3, marginBottom: 11 }}>
                          <FormattedMessage id="special_requirements" />
                        </Form.Label>
                      </Col>
                      {/* <Col md={1} style={{ paddingTop: 3 }}>
                      <ButtonGroup className="mx-3">
                        <Button
                          size="sm"
                          name="leela_special_req_button"
                          onClick={handleButtonClick}
                          value="Yes"
                          variant={
                            otherAllergiesButtonValue.leela_special_req_button ===
                            "Yes"
                              ? "secondary"
                              : "light"
                          }
                        >
                          <FormattedMessage id="yes" />
                        </Button>
                        <Button
                          size="sm"
                          name="leela_special_req_button"
                          onClick={handleButtonClick}
                          value="No"
                          variant={
                            otherAllergiesButtonValue.leela_special_req_button ===
                            "No"
                              ? "secondary"
                              : "light"
                          }
                        >
                          <FormattedMessage id="no" />
                        </Button>
                      </ButtonGroup>
                    </Col> */}
                      <Col md={9} className="ps-4">
                        {/* {otherAllergiesButtonValue.leela_special_req_button ===
                        "Yes" && ( */}
                        <FormattedMessage id="special_requirements">
                          {(placeholder) => (
                            <Form.Control
                              value={formData.leela_special_req}
                              placeholder={placeholder}
                              type="text"
                              name="leela_special_req"
                              onChange={handleChange}
                            />
                          )}
                        </FormattedMessage>
                        {/* )} */}
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <SectionSeparator title="title.other_allergy" />
                <Row>
                  <Col md={12}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="allergies" />
                      </Form.Label>
                      <Form.Control
                        value={formData.allergies}
                        type="text"
                        name="allergies"
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="allergic_reactions" />
                      </Form.Label>
                      <Form.Control
                        value={formData.allergic_reactions}
                        type="text"
                        name="allergic_reactions"
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}

            {/* STEP 6 */}
            {step === 6 && (
              <>
                <QASection
                  errors={errors}
                  data={questions ? questions : []}
                  centerId={formData?.center_id}
                  admissionId={formData?.admission_id}
                  qaAnswers={formData?.qaAnswers}
                  setFormData={setFormData}
                  locale={locale}
                />
              </>
            )}

            {/* STEP 7 */}
            {step === 7 && (
              <>
                {admissionAttachments.length > 0 && (
                  <>
                    <SectionSeparator title="title.settling_in_policy" />
                    <ul>
                      {admissionAttachments.map((attachment, index) => (
                        <li key={index}>
                          <Button
                            onClick={() =>
                              setAdmissionAttachmentModal({
                                show: true,
                                title: attachment.title,
                                content: attachment.text,
                              })
                            }
                            variant="link"
                          >
                            {attachment.title}
                          </Button>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
                <SectionSeparator title="title.acknowledgement" />
                <Row className="mb-4">
                  <Col md={"auto"}>
                    <Form.Check
                      classNamehecked={formData?.check_acknowledgement == 1}
                      type="checkbox"
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          check_acknowledgement: e.target.checked ? 1 : 0,
                        }))
                      }
                    />
                  </Col>
                  <Col>
                    <FormattedMessage id="acknowledgement" />
                  </Col>
                </Row>
                <SignaturePad
                  signature={signature}
                  setSignature={setSignature}
                  admissionID={formData.admission_id}
                  setFormData={setFormData}
                  error={errors?.signature}
                />
              </>
            )}
          </div>
        </div>
      </div>
      <Modal
        size="xl"
        show={admissionAttachmentModal.show}
        onHide={() =>
          setAdmissionAttachmentModal({
            show: false,
            title: "",
            content: "",
          })
        }
      >
        <Modal.Header closeButton>
          <Modal.Title>{admissionAttachmentModal.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            dangerouslySetInnerHTML={{
              __html: admissionAttachmentModal.content,
            }}
          />
        </Modal.Body>
      </Modal>
      <ToastContainer
        position={locale === "en" ? "bottom-right" : "bottom-left"}
        rtl={locale === "ar"}
        hideProgressBar={true}
        theme="colored"
      />
    </IntlProvider>
  );
};

export default App;
